import { createSelector } from 'reselect';
import metaSelector from 'Selectors/metaSelector';

const messagesviewSelector = state => state.messagesview;

export default createSelector(
	[messagesviewSelector, metaSelector],
	(messagesview, meta) => {
		return {
			messagesview: messagesview,
			meta: meta
		};
	}
);



// WEBPACK FOOTER //
// ./src/selectors/messagesSelector.js